<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Taqeeq"
  >
    <rect x="2" y="2" width="44" height="44" rx="11" fill="#0a0f0d" />
    <rect x="12" y="11" width="24" height="3.5" rx="1.75" fill="#33443b" />
    <rect x="12" y="18" width="18" height="3.5" rx="1.75" fill="#223028" />
    <rect x="12" y="25" width="22" height="3.5" rx="1.75" fill="#223028" />
    <path
      d="M12 35 C14 30 16 29.5 17.5 33.5 C19 37.5 21 38 23 34"
      stroke="#2ce5ff"
      stroke-width="2.2"
      fill="none"
      stroke-linecap="round"
    />
    <circle cx="33" cy="32" r="9" fill="none" stroke="#c9f031" stroke-width="2" />
    <path
      d="M28.8 32 L31.6 34.8 L37.4 28.6"
      stroke="#c9f031"
      stroke-width="2.2"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
